export default () => {
	// ! Important: Wait until page has fully loaded before scrolling (#Chrome bug)
	window.addEventListener('load', () => {
		if (window.location.hash) {
			window.scrollTo(0, 0);
			setTimeout(() => {
				scrollToElement(window.location.hash);
			}, 1);
		}
	});

	document.addEventListener(
		'click',
		function (e) {
			// loop parent nodes from the target to the delegation node
			for (let target = e.target; target && target != this; target = target.parentNode) {
				if (target.matches('a[href^="#"]:not([href="#"]):not([href="#/"]):not(._brlbs-btn)')) {
					e.preventDefault();
					scrollToElement(target.getAttribute('href'));
					break;
				}
			}
		},
		false,
	);
};

export const scrollToElement = (selector) => {
	const targetEl = document.querySelector(selector);
	if (!targetEl) {
		return;
	}

	// Set initial scroll to an offset to increase headroom
	let scrollOffset = 32;

	// Add header height to offset if necessary
	const headerBar = document.querySelector('header.nav');
	scrollOffset += headerBar?.getBoundingClientRect().height || 0;

	// Add height of WP admin bar for logged in users
	if (document.querySelector('#wpadminbar')) {
		scrollOffset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
	}

	// Start scrolling
	window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top - scrollOffset);
};
